import { useState } from 'react';
import LangflowButton from './components/LangflowButton';
import LangflowChatContextProvider from './contexts/LangflowChat.context';
import { LangflowContent } from './components/LangflowContent/LangflowContent';
import LangflowHistory from './components/LangflowContent/LangflowHistory/LangflowHistory';
import { LangflowHeader } from './components/LangflowHeader/LangflowHeader';
import './LangflowChat.scss';
import useLangflowMetrics from './useLangflowMetrics';

const LangflowChat: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);
  const { dispatchChatToggleMetric } = useLangflowMetrics();

  const handleOpenChat = (shouldOpen: boolean) => {
    setIsOpen(shouldOpen);
    dispatchChatToggleMetric(shouldOpen);
  };

  return (
    <LangflowChatContextProvider>
      <div className="langflow-chat-button-container">
        <LangflowButton onClick={() => handleOpenChat(!isOpen)} isOpen={isOpen} />
      </div>
      {isOpen && (
        <div className="langflow-chat-container">
          {!isHistoryOpen ? (
            <>
              <LangflowHeader
                isOpen={isOpen}
                setIsOpen={handleOpenChat}
                setIsHistoryOpen={setIsHistoryOpen}
              />
              <LangflowContent />
            </>
          ) : (
            <LangflowHistory setIsHistoryOpen={setIsHistoryOpen} setIsOpen={handleOpenChat} />
          )}
        </div>
      )}
    </LangflowChatContextProvider>
  );
};

export default LangflowChat;
